import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';
import * as React from 'react';

const KeyIcon = ({ sx, ...props }: SvgIconProps) => {
  return (
    <SvgIcon viewBox="0 0 18 18" sx={{ height: '18px', width: '18px', ...sx }} {...props}>
      <g clipPath="url(#clip0_636_367)">
        <path
          d="M9.53181 7.36366C8.85681 5.45728 7.04455 4.09094 4.90909 4.09094C2.19682 4.09094 0 6.28776 0 9.00004C0 11.7123 2.19682 13.9091 4.90909 13.9091C7.04455 13.9091 8.85681 12.5428 9.53181 10.6364H13.0909V13.9091H16.3636V10.6364H18V7.36366H9.53181ZM4.90909 10.6364C4.00502 10.6364 3.27272 9.90412 3.27272 9C3.27272 8.09588 4.00502 7.36366 4.90909 7.36366C5.81317 7.36366 6.54547 8.09592 6.54547 9.00004C6.54547 9.90415 5.81317 10.6364 4.90909 10.6364Z"
          fill="#0072CE"
        />
      </g>
      <defs>
        <clipPath id="clip0_636_367">
          <rect width="18" height="18" fill="white" />
        </clipPath>
      </defs>
    </SvgIcon>
  );
};

export default KeyIcon;
